export const TypesLacres = {
    LACRES: "LACRES",
    ADD_LACRE: "ADD_LACRE",
    REMOVE_LACRE: "REMOVE_LACRE",
    RESETLACRES: "RESETLACRES",
    LACRE_SELECIONADO: "LACRE_SELECIONADO",
    LACRE_DIGITADO: "LACRE_DIGITADO"
}

const INITIAL = {
    $id: 0,
    Sucesso: false,
    Mensagem: "",
    TiposDeLacre: [],
    LacresManifestados: [],
    Lacres: [],
    LacreSelecionado: '',
    LacreSelecionadoId: 0,
    LacreDigitado: ''
}

export default function lacresReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesLacres.LACRES:
            return {
                ...state,
                $id: action.payload.$id,
                Sucesso: action.payload.Sucesso,
                Mensagem: action.payload.Mensagem,
                TiposDeLacre: action.payload.TiposDeLacre,
                LacresManifestados: action.payload.LacresManifestados,
                Lacres: action.payload.Lacres
            };
        case TypesLacres.ADD_LACRE:
            return {
                ...state,
                Lacres: action.payload
            };
        case TypesLacres.REMOVE_LACRE:
            return ({
                ...state,
                Lacres: [...state.Lacres.filter(function (a) { return !action.payload.includes(a.LacreId) })]
            })
        case TypesLacres.LACRE_SELECIONADO:
            return {
                ...state,
                LacreSelecionado: action.payload.LacreSelecionado,
                LacreSelecionadoId: action.payload.LacreSelecionadoId
            };
        case TypesLacres.LACRE_DIGITADO:
            return {
                ...state,
                LacreDigitado: action.payload.LacreDigitado
            };
        case TypesLacres.RESETLACRES:
            return INITIAL;

        default:
            return state;
    }
}

export const LacresActions = {
    getLacres,
    addLacres,
    deletarLacres,
    selecionarLacre,
    digitarLacre,
    resetLacresState
}

function getLacres(dadosLacres) {
    return {
        type: TypesLacres.LACRES,
        payload: dadosLacres
    }
}

function addLacres(dadosLacres) {
    return {
        type: TypesLacres.ADD_LACRE,
        payload: dadosLacres
    }
}

function selecionarLacre(lacre, id) {
    return {
        type: TypesLacres.LACRE_SELECIONADO,
        payload: { LacreSelecionado: lacre, LacreSelecionadoId: id }
    }
}

function digitarLacre(lacre) {
    return {
        type: TypesLacres.LACRE_DIGITADO,
        payload: { LacreDigitado: lacre }
    }
}

function deletarLacres(lacre) {

    let lacreDescricaoRemover = [];

    lacre.forEach(element => {
        lacreDescricaoRemover.push(element[0]);
    });

    return {
        type: TypesLacres.REMOVE_LACRE,
        payload: lacreDescricaoRemover
    }
}

function resetLacresState() {
    return { type: "RESETLACRES" }
}